import { createMetaThemeVariant } from './utils.mjs';
import { themeNameDefault } from './constants.mjs';
import { metaThemeLightPartial } from './light.mjs';
import { metaThemeLightUpliftPartial } from './light-uplift.mjs';

var metaThemeVariantPartials = {
  light: metaThemeLightPartial,
  'Polaris-Summer-Editions-2023': metaThemeLightUpliftPartial
};
var metaThemeDefaultPartial = metaThemeVariantPartials[themeNameDefault];
var metaThemeDefault = createMetaThemeVariant(metaThemeDefaultPartial);

export { createMetaThemeVariant, metaThemeDefault, metaThemeDefaultPartial, metaThemeVariantPartials };
